import { useQuery } from "@tanstack/react-query";
import { useLoginContext } from "../../../App";
import { fetchQuantitativeDimensionalTypesData } from "../../../services/b2b-indicators-apiService";
import useB2BTranslation from "../../b2b-common/hooks/useB2BTranslation";
import { showNotification } from "../../b2b-common/Notification";
import { useContentContext } from "../../layout/Layout";

const useQuantitativeDimensionalTypes = () => {
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const { t } = useB2BTranslation('b2b-indicators');

    const getQuantitativeDimensionalTypes = async () => {
        try {
            const data = await fetchQuantitativeDimensionalTypesData(loginData.accessToken);
            return data;
        } catch (error) {
            showNotification(setNotification, t('Error fetching quantitative dimensional types'), 'error', 5000);
        }
    }

    const { data: quantitativeDimensionalTypes } = useQuery({
        queryKey: ['quantitativeDimensionalTypes'],
        queryFn: () => getQuantitativeDimensionalTypes(),
    });

    return quantitativeDimensionalTypes;
}

export default useQuantitativeDimensionalTypes;